import React from "react";

export const Banner = ({ value, onClick }) => {
    return (
        <section className="banner" id="hrefInicio">
            {/* <div className="banner-text">
                <h1>Academia Balam Boox</h1>
                <legend>•Estilo 2023•</legend>
            </div> */}
        </section>
    );
}